import BaseAPI from "./BaseAPI";
import { getAPIUrlV2 } from "../apiConfig";
import { supplierRoute } from "../routes";

export default class SupplierAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, supplierRoute, "supplier");
    }

    async Create(data) {
        const result = await this._request("post", this._url(), data);
        this._emit("create", result.id);
        return result;
    }

    async MarkArchived(id) {
        const result = await this._request("post", `${getAPIUrlV2("control/suppliers")}/mark-archived?id=${id}`);
        this._emit("mark-archived", id);
        return result;
    }

    getEmptySupplier() {
        return {
            name: "",
            plant_id: "",
            location: "",
            website: ""
        };
    }
}
